/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { useDispatch } from 'react-redux';
import { sameAuthor, sameCategory } from '../redux/filters/actions';

export default function SingleCard({ blog }) {
    const { title, category, img, author, authorImg, date, publishedTime } = blog;
    const dispatch = useDispatch();

    const handleCategoryChange = (blogCategory) => {
        dispatch(sameCategory(blogCategory));
    };

    const handleAuthorChange = (blogAuthor) => {
        dispatch(sameAuthor(blogAuthor));
    };

    return (
        <div className="flex flex-col rounded-lg shadow-lg overflow-hidden">
            <div className="flex-shrink-0">
                <img className="h-48 w-full object-cover" src={img} alt="" />
            </div>

            <div className="flex-1 bg-white p-6 flex flex-col justify-between">
                <div className="flex-1">
                    <p className="text-sm font-medium text-indigo-600">
                        <span
                            className="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-indigo-100 text-indigo-800 cursor-pointer"
                            onClick={() => handleCategoryChange(category)}
                        >
                            {category}
                        </span>
                    </p>
                    <a href="#" className="block mt-1">
                        <p className="text-xl font-semibold text-gray-900">{title}</p>
                    </a>
                </div>
                <div className="mt-6 flex items-center">
                    <div className="flex-shrink-0" onClick={() => handleAuthorChange(author)}>
                        <img className="h-10 w-10 rounded-full" src={authorImg} alt="" />
                    </div>
                    <div className="ml-3">
                        <p
                            className="text-sm font-medium text-gray-900 hover:underline cursor-pointer"
                            onClick={() => handleAuthorChange(author)}
                        >
                            {author}
                        </p>
                        <div className="flex space-x-1 text-sm text-gray-500">
                            <time dateTime="2020-03-16">{date}</time>
                            <span aria-hidden="true">&middot;</span>
                            <span> {publishedTime} </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
